import React, { FunctionComponent } from "react";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import Styles from "./Dropdown.module.css";
type props = {
  title?: string;
  option?: any[];
  setDetails?: () => void;
  setSelectedValue: (val: any) => any;
  selectedValue?: any;
  disable?: boolean;
  choices?: any[];
  isMulti?: boolean;
  style?: any;
  direction?:any;
  classNameModifier?: any;
  // values?:any;
};
const animatedComponents = makeAnimated();
const DropdownWithValue: FunctionComponent<props> = ({
  option,
  selectedValue,
  setSelectedValue,
  disable,
  choices,
  isMulti,
  style,
  direction,
  classNameModifier
}) => {
    
  const choice:any = () => {
    if (option) {
      const data = option.map((item: any, index: number) => {
        return ( 
        { value: item.value, label: item.label }
      )
    });
    return data;
    } else {
      return choices ? choices : [];
    }
  };

  return (
    <>
      <Select
        className={`${Styles.select} ${classNameModifier}`}
        menuPlacement={direction?direction:"auto"}
        maxMenuHeight={120}
        options={choice()}
        value={selectedValue}
        components={animatedComponents}
        onChange={(data) =>{
          setSelectedValue(data);
        }}
        showCheckbox={true}
        isSearchable={true}
        isDisabled={disable ? true : choice().length === 0 ? true : false}
        isMulti={isMulti}
        style={style}
      />
    </>
  );
};

export default DropdownWithValue;
